import { create } from 'zustand';

export interface Customer {
  name: string;
  cpf: string;
  birthDate: string;
  email: string;
  phone: string;
  gender?: string;
  state?: string;  // UF code (e.g., 'SP', 'RJ')
  city?: string;   // City name
  consentLgpd: boolean;
  consentTerms: boolean;
  consentNotifications: boolean;
  customerId?: string; // ID returned by the register API
}

export interface Reservation {
  storeId?: string;
  storeCode?: string;
  storeName?: string;
  storeCity?: string;
  storeState?: string;
  scheduledDate?: string;
  voucherCode?: string;
  qrCodeToken?: string;
  redeemedAt?: string;
}

export interface UserLocation {
  lat: number;
  lng: number;
}

export interface Campaign {
  id: string;
  name: string;
  description: string;
  productName: string;
  productDescription: string;
  productImage: string;
  startDate: string;
  endDate: string;
  regulationPdfUrl?: string;
  faqPdfUrl?: string;
  availableDates: any[];
  stores: any[];
}

interface VoucherState {
  currentStep: number;
  customer: Partial<Customer> | null;
  reservation: Partial<Reservation> | null;
  userLocation: UserLocation | null;
  campaign: Campaign | null;

  setCurrentStep: (step: number) => void;
  updateCustomer: (data: Partial<Customer>) => void;
  updateReservation: (data: Partial<Reservation>) => void;
  setUserLocation: (location: UserLocation | null) => void;
  selectDate: (date: string) => void;
  setCampaign: (campaign: Campaign) => void;
  reset: () => void;
}

export const useVoucherStore = create<VoucherState>((set) => ({
  currentStep: 0,
  customer: null,
  reservation: null,
  userLocation: null,
  campaign: null,

  setCurrentStep: (step) => set({ currentStep: step }),

  updateCustomer: (data) =>
    set((state) => ({ customer: { ...state.customer, ...data } })),

  updateReservation: (data) =>
    set((state) => ({ reservation: { ...state.reservation, ...data } })),

  setUserLocation: (location) => set({ userLocation: location }),

  selectDate: (date) =>
    set((state) => ({ reservation: { ...state.reservation, scheduledDate: date } })),

  setCampaign: (campaign) => set({ campaign }),

  reset: () => set({ currentStep: 0, customer: null, reservation: null, userLocation: null }),
}));
